var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pr-wrapper',{staticClass:"flex-column align-items-center justify-content-center h-100",attrs:{"id":"splash","fs":"","bg":"","zi":"998"}},[_c('img',{attrs:{"src":require("@/assets/images/software.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }